// Indonesian translations
export const id = {
  // Navigation
  'nav.home': 'Beranda',
  'nav.profile': 'Profil',
  'nav.admission': 'Pendaftaran',
  'nav.news': 'Berita',
  'nav.services': 'Layanan',
  'nav.research': 'Riset & Publikasi',
  'nav.search': 'Pencarian',
  'nav.portal': 'Portal Mahasiswa',
  'nav.menu': 'Menu',
  'nav.event': 'Agenda',
  'nav.information': 'Informasi',
  'nav.announcement': 'Pengumuman',
  'nav.bulletin': 'Buletin',
  'nav.gallery': 'Galeri',
  'nav.ppid': 'PPID',
  'nav.researchTraining': 'Penelitian & Pelatihan',
  'nav.seminarWebinar': 'Seminar & Webinar',
  'nav.others': 'Lainnya',

  // Profile submenu
  'nav.about': 'Tentang UNMUL',
  'nav.history': 'Sejarah & Visi Misi',

  // History Section
  'history.title': 'Sejarah Singkat',
  'history.label': 'Awal Mula',
  'history.established': 'Tahun Berdiri',

  // Vision Mission Section
  'visionMission.label': 'Visi & Misi',
  'visionMission.title': 'Arah Menuju',
  'visionMission.subtitle': 'Masa Depan',
  'visionMission.vision': 'Visi',
  'visionMission.mission': 'Misi',

  // Core Values Section
  'coreValues.title': 'Nilai-Nilai',
  'coreValues.subtitle': 'Inti',
  'coreValues.description': 'Prinsip yang kami pegang teguh dalam menjalankan Tri Dharma Perguruan Tinggi',
  'coreValues.integrity': 'Integritas',
  'coreValues.integrityDesc': 'Menjunjung tinggi kejujuran dan etika dalam segala aspek akademik dan organisasi.',
  'coreValues.innovation': 'Inovasi',
  'coreValues.innovationDesc': 'Mendorong kreativitas dan pemikiran baru untuk solusi tantangan masa depan.',
  'coreValues.collaboration': 'Kolaborasi',
  'coreValues.collaborationDesc': 'Membangun kemitraan yang kuat dengan berbagai pihak untuk kemajuan bersama.',
  'coreValues.sustainability': 'Keberlanjutan',
  'coreValues.sustainabilityDesc': 'Berkomitmen untuk kelestarian lingkungan dan pembangunan berkelanjutan.',

  'nav.structure': 'Struktur Organisasi',
  'nav.leadership': 'Pimpinan',
  'nav.campusMap': 'Peta Kampus',
  'nav.academic': 'Akademik',
  'nav.academicInfo': 'Informasi Akademik',
  'nav.faculties': 'Fakultas',
  'nav.researchLink': 'Riset & Inovasi',
  'nav.studentAffairs': 'Kemahasiswaan',
  'nav.cooperation': 'Kerjasama',
  'nav.contact': 'Hubungi Kami',

  // Admission submenu
  'nav.pmbInfo': 'Informasi PMB',
  'nav.snbp': 'Jalur SNBP',
  'nav.snbt': 'Jalur SNBT',
  'nav.mandiri': 'Jalur Mandiri',

  // Services submenu
  'nav.infoSystem': 'Sistem Informasi',
  'nav.ais': 'AIS',
  'nav.elearning': 'E-Learning',
  'nav.repository': 'Repository',
  'nav.ejournal': 'E-Journal',
  'nav.studentServices': 'Layanan Mahasiswa',
  'nav.digitalLibrary': 'Perpustakaan Digital',
  'nav.scholarship': 'Beasiswa',
  'nav.ukm': 'UKM & Organisasi',
  'nav.counseling': 'Konseling Mahasiswa',
  'nav.generalServices': 'Layanan Umum',
  'nav.helpdesk': 'Helpdesk IT',
  'nav.correspondence': 'Persuratan Online',
  'nav.privacy': 'Kebijakan Privasi',
  'nav.faq': 'FAQ',
  'nav.staffDosen': 'Staff & Dosen',

  // Research submenu
  'nav.researchCenter': 'Pusat Riset',
  'nav.lp2m': 'LP2M',
  'nav.tropicalStudy': 'Pusat Studi Tropis',
  'nav.labs': 'Laboratorium Unggulan',
  'nav.haki': 'HaKI & Paten',
  'nav.publications': 'Publikasi Ilmiah',
  'nav.journals': 'Jurnal UNMUL',
  'nav.proceedings': 'Prosiding Konferensi',
  'nav.researchRepo': 'Repository Riset',
  'nav.indexed': 'Artikel Terindeks',

  // Hero section
  'hero.badge': 'Perguruan Tinggi Negeri Terkemuka di Kalimantan',
  'hero.title1': 'Universitas',
  'hero.title2': 'Mulawarman',
  'hero.subtitle': 'Menjadi universitas yang menghasilkan sumber daya insani yang berkarakter dan berdaya saing global dalam pengembangan ilmu pengetahuan, teknologi, seni dan budaya berbasis sumber daya alam dan kearifan lokal.',
  'hero.cta.register': 'Daftar Sekarang',
  'hero.cta.explore': 'Jelajahi Program',
  'hero.cta.watchProfile': 'Tonton Profil',
  'hero.mainTitle1': 'Membangun Peradaban',
  'hero.mainTitle2': 'Di Jantung Nusantara',

  // Stats
  'stats.faculties': 'Fakultas',
  'stats.programs': 'Program Studi',
  'stats.students': 'Mahasiswa Aktif',
  'stats.accreditation': 'Akreditasi',
  'stats.lecturers': 'Dosen',
  'stats.alumni': 'Alumni',
  'stats.staff': 'Tenaga Kependidikan',
  'stats.sectionTitle': '{siteName} dalam Angka',
  'stats.sectionSubtitle': 'Data terkini mengenai universitas kami',
  'stats.studentDist': 'Distribusi Mahasiswa',
  'stats.byProgram': 'Berdasarkan Program',
  'stats.staffDist': 'Distribusi Dosen',
  'stats.byRank': 'Berdasarkan Jabatan',
  'stats.studentByYear': 'Mahasiswa per Angkatan',
  'stats.yearlyDistribution': 'Distribusi Tahunan',

  // News Section
  'news.title': 'Kabar Kampus',
  'news.viewAll': 'Lihat Semua Berita',
  'news.noNews': 'Tidak ada berita terbaru.',
  'news.announcement': 'Pengumuman',
  'news.gallery': 'Galeri',

  // Sections
  'section.news': 'Berita & Pengumuman',
  'section.newsSubtitle': 'Informasi terkini dari {siteName}',
  'section.faculties': 'Fakultas',
  'section.facultiesSubtitle': 'Pilih fakultas yang sesuai dengan minat dan bakatmu',
  'section.admission': 'Pendaftaran Mahasiswa Baru',
  'section.admissionSubtitle': 'Bergabunglah dengan keluarga besar {siteName}',

  // Footer
  'footer.about': '{siteName} adalah perguruan tinggi negeri terkemuka di Kalimantan Timur yang didirikan pada tahun 1962.',
  'footer.quickLinks': 'Tautan Cepat',
  'footer.contact': 'Kontak',
  'footer.address': 'Jl. Kuaro, Gunung Kelua, Samarinda',
  'footer.newsletter': 'Newsletter',
  'footer.newsletterText': 'Dapatkan informasi terbaru dari {siteName}',
  'footer.subscribe': 'Berlangganan',
  'footer.rights': 'Hak Cipta',
  'footer.aboutUs': 'Tentang Kami',
  'footer.academic': 'Akademik',
  'footer.registration': 'Pendaftaran',
  'footer.researchInnovation': 'Riset & Inovasi',
  'footer.studentAffairs': 'Kemahasiswaan',
  'footer.cooperation': 'Kerjasama',
  'footer.contactUs': 'Hubungi Kami',
  'footer.privacyPolicy': 'Kebijakan Privasi',
  'footer.terms': 'Syarat & Ketentuan',
  'footer.sitemap': 'Peta Situs',
  'footer.emailPlaceholder': 'Email Anda',
  'footer.workingHours': 'Senin - Jumat: 08:00 - 16:00',

  // Common
  'common.readMore': 'Baca Selengkapnya',
  'common.viewAll': 'Lihat Semua',
  'common.learnMore': 'Pelajari Lebih',
  'common.submit': 'Kirim',
  'common.search': 'Cari...',
  'common.loading': 'Memuat...',
  'common.backToHome': 'Kembali ke Beranda',
  'common.pageNotFound': 'Halaman Tidak Ditemukan',
  'common.updated': 'Diperbarui',
  'common.download': 'Unduh',
  'common.external': 'Tautan Eksternal',
  'common.allRightsReserved': 'Hak Cipta Dilindungi',
  'common.journey': 'Perjalanan',
  'common.us': 'Kami',

  // Agenda Section
  'agenda.title': 'Agenda Kampus',
  'agenda.subtitle': 'Kegiatan dan acara terbaru',
  'agenda.viewAll': 'Lihat Semua Agenda',
  'agenda.noEvents': 'Tidak ada agenda terbaru.',

  // Announcement Section
  'announcement.title': 'Pengumuman',
  'announcement.subtitle': 'Informasi penting terbaru',
  'announcement.viewAll': 'Lihat Semua Pengumuman',
  'announcement.noAnnouncements': 'Tidak ada pengumuman terbaru.',
  'announcement.label': 'PENGUMUMAN',

  // Rektor Section
  'rektor.name': 'Prof. Dr. Ir. H. Abdunnur, M.Si',
  'rektor.title': 'Rektor {siteName}',
  'rektor.position_dynamic': '{role} {siteName}',
  'rektor.greeting': 'SAMBUTAN {role}',
  'rektor.quote': '"Menuju World Class University Berbasis', // Note: Tropical Studies is usually kept or specific
  'rektor.quoteHighlight': 'Tropical Studies',
  'rektor.paragraph1': 'Selamat datang di {siteName}. Sebagai universitas terbesar dan tertua di Kalimantan Timur, kami memikul mandat sejarah untuk menjadi pusat peradaban baru di Ibu Kota Nusantara.',
  'rektor.paragraph2': 'Kami berdedikasi menciptakan ekosistem akademik yang tidak hanya unggul dalam sains dan teknologi, tetapi juga berakar kuat pada pelestarian hutan hujan tropis yang menjadi paru-paru dunia.',

  // Contact Page
  'contact.title': 'Hubungi Kami',
  'contact.breadcrumb': 'Kontak',
  'contact.hero.subtitle': 'Ada pertanyaan? Jangan ragu untuk menghubungi kami melalui berbagai saluran yang tersedia.',
  'contact.department.title': 'Kontak Departemen',
  'contact.location.title': 'Lokasi Kampus',
  'contact.address.title': 'Alamat Utama',
  'contact.social.title': 'Media Sosial',
  'contact.quick.title': 'Butuh Bantuan Cepat?',
  'contact.whatsapp': 'Chat via WhatsApp',
  'contact.dept.rectorate': 'Rektorat',
  'contact.dept.academic': 'Bagian Akademik',
  'contact.dept.student': 'Bagian Kemahasiswaan',
  'contact.dept.finance': 'Bagian Keuangan',
  'contact.dept.pr': 'Humas',
  'contact.dept.admission': 'PMB (Pendaftaran)',

  // Admission Page
  'admission.title': 'Pendaftaran Mahasiswa Baru',
  'admission.breadcrumb': 'Pendaftaran',
  'admission.status.open': 'PENDAFTARAN DIBUKA',
  'admission.hero.title': 'Pendaftaran Mahasiswa Baru',
  'admission.hero.subtitle': 'Wujudkan mimpimu menjadi bagian dari keluarga besar {siteName}. Pilih jalur masuk yang sesuai dengan kemampuanmu.',
  'admission.portal': 'Portal PMB',
  'admission.viewPaths': 'Lihat Jalur Masuk',
  'admission.paths.title': 'Jalur Masuk {siteName}',
  'admission.paths.subtitle': 'Pilih jalur pendaftaran yang paling sesuai dengan profil dan kemampuanmu',
  'admission.popular': 'PALING POPULER',
  'admission.timeline': 'Jadwal',
  'admission.moreInfo': 'Info Lengkap',
  'admission.steps.title': 'Langkah Pendaftaran',
  'admission.cta.title': 'Ada Pertanyaan?',
  'admission.cta.subtitle': 'Hubungi tim Helpdesk PMB kami untuk mendapatkan bantuan seputar pendaftaran mahasiswa baru.',

  // Admission Paths & Steps
  'admission.path.snbp.title': 'Seleksi Nasional Berdasarkan Prestasi',
  'admission.path.snbp.desc': 'Seleksi tanpa tes berdasarkan prestasi akademik dan non-akademik selama di SMA/SMK/MA.',
  'admission.path.snbt.title': 'Seleksi Nasional Berdasarkan Tes',
  'admission.path.snbt.desc': 'Seleksi melalui Ujian Tulis Berbasis Komputer (UTBK) yang mengukur kemampuan penalaran.',
  'admission.path.mandiri.title': 'Seleksi Mandiri Masuk PTN',
  'admission.path.mandiri.desc': 'Jalur mandiri yang diselenggarakan langsung oleh {siteName}.',

  'admission.step.1.title': 'Buat Akun',
  'admission.step.1.desc': 'Daftar akun di portal PMB dengan email aktif',
  'admission.step.2.title': 'Lengkapi Data',
  'admission.step.2.desc': 'Isi formulir biodata dan pilih program studi',
  'admission.step.3.title': 'Upload Dokumen',
  'admission.step.3.desc': 'Unggah foto, ijazah, dan dokumen pendukung',
  'admission.step.4.title': 'Pembayaran',
  'admission.step.4.desc': 'Bayar biaya pendaftaran via bank/e-wallet',
  'admission.step.5.title': 'Cetak Kartu',
  'admission.step.5.desc': 'Unduh kartu peserta ujian',

  // Fakultas Page
  'faculties.search': 'Cari fakultas atau program studi...',
  'faculties.breadcrumb': 'Fakultas',
  'faculties.badge.count': '{count} Fakultas',
  'faculties.badge.programs': '100+ Program Studi',
  'faculties.title.explore': 'Jelajahi',
  'faculties.title.faculties': 'Fakultas',
  'faculties.title.programs': 'dan Program Studi',
  'faculties.subtitle': 'Temukan program studi impian Anda dari berbagai jenjang pendidikan di 15 fakultas terbaik {siteName}',
  'faculties.description': 'Saat ini {siteName} memiliki <strong class="text-unmulYellow">15 fakultas</strong> dengan lebih dari <strong class="text-unmulYellow">100 program studi</strong> dari jenjang Diploma, Sarjana, Magister, Doktor, hingga Profesi. Fakultas tersebut adalah:',
  'faculties.stats.faculties': 'Fakultas',
  'faculties.stats.program': 'Program Studi',
  'faculties.stats.level': 'Jenjang',
  'faculties.stats.profession': 'Profesi',
  'faculties.section.title': 'Pilih',
  'faculties.section.titleHighlight': 'Fakultas Anda',
  'faculties.section.subtitle': 'Cari dan temukan fakultas atau program studi yang Anda inginkan',
  'faculties.card.programs': '{count} Program Studi',
  'faculties.card.showAll': 'Lihat semua',
  'faculties.card.showProdi': 'Lihat semua {count} prodi',
  'faculties.card.hide': 'Sembunyikan',
  'faculties.card.visit': 'Kunjungi Website',
  'faculties.noResults.title': 'Tidak ada hasil ditemukan',
  'faculties.noResults.subtitle': 'Coba kata kunci lain untuk mencari fakultas atau program studi',
  'faculties.noResults.reset': 'Reset Pencarian',
  'faculties.cta.title': 'Siap Memulai Perjalanan Akademik Anda?',
  'faculties.cta.subtitle': 'Temukan program studi yang sesuai dengan minat dan bakat Anda. Raih masa depan cemerlang bersama {siteName}!',
  'faculties.cta.button': 'Informasi Pendaftaran',
  'faculties.cta.contact': 'Hubungi Kami',

  // Admission Landing Section
  'admissionSection.title': 'Jalur Masuk {siteName} {year}',
  'admissionSection.subtitle': 'Siapkan dirimu untuk menjadi bagian dari keluarga besar {siteName}.',
  'admissionSection.snbp.title': 'SNBP',
  'admissionSection.snbp.desc': 'Seleksi Nasional Berdasarkan Prestasi (Tanpa Tes).',
  'admissionSection.snbp.item1': 'Nilai Rapor Semester 1-5',
  'admissionSection.snbp.item2': 'Prestasi Akademik/Non',
  'admissionSection.snbp.item3': 'Portofolio (Seni/Olahraga)',
  'admissionSection.snbp.button': 'Info Detail',
  'admissionSection.snbt.title': 'SNBT',
  'admissionSection.snbt.desc': 'Seleksi Nasional Berdasarkan Tes (UTBK).',
  'admissionSection.snbt.item1': 'Tes Potensi Skolastik',
  'admissionSection.snbt.item2': 'Literasi Bahasa',
  'admissionSection.snbt.item3': 'Penalaran Matematika',
  'admissionSection.snbt.button': 'Cek Jadwal',
  'admissionSection.snbt.popular': 'PALING POPULER',
  'admissionSection.mandiri.title': 'SMMPTN',
  'admissionSection.mandiri.desc': 'Seleksi Mandiri Masuk Perguruan Tinggi Negeri.',
  'admissionSection.mandiri.item1': 'Ujian Tulis Mandiri',
  'admissionSection.mandiri.item2': 'Jalur Rekognisi Prestasi',
  'admissionSection.mandiri.item3': 'Afirmasi Daerah',
  'admissionSection.mandiri.button': 'Daftar Akun',

  // CTA Section
  'cta.title': 'Siap Bergabung dengan Kami?',
  'cta.subtitle': 'Jadilah bagian dari generasi penerus bangsa yang berkontribusi untuk Indonesia dari Jantung Nusantara.',
  'cta.register': 'Daftar Sekarang',
  'cta.visitCampus': 'Kunjungi Kampus',
};

export default id;

